<div class="card-header">
    <ng-content></ng-content>
</div>